export function isToggleOn(config, key, defaultValue = true) {
    if (typeof config === 'boolean') {
        return config;
    }
    if (!config || typeof config[key] !== 'boolean') {
        return defaultValue;
    }
    return config[key] ?? defaultValue;
}
//# sourceMappingURL=toggle.js.map